/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React from 'react';
import classes from './Body.module.css';
import { Header, FilterHeader } from '../Header';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const Body = props => {
  const {
    goBack,
    sectionView,
    toggleCheckbox,
    changeView,
    excludeTerminated,
    jobAllowsAssignment,
    assigned,
    sortByName,
    onChangeSortByName,
    searchEmployeeValue,
    onSearchEmployee,
  } = props;

  return (
    <div className={classes.container}>
      <Header
        goBack={goBack}
        toggleCheckbox={toggleCheckbox}
        changeView={changeView}
        sectionView={sectionView}
        excludeTerminated={excludeTerminated}
        jobAllowsAssignment={jobAllowsAssignment}
        assigned={assigned}
      />
      <div className={classes.bodyWrapper}>
        <div className={classes.leftSectionWrapper}>
          <FilterHeader
            sortByName={sortByName}
            onChangeSortByName={onChangeSortByName}
            sectionView={sectionView}
            searchEmployeeValue={searchEmployeeValue}
            onSearchEmployee={onSearchEmployee}
          />
          <LeftSection {...props} />
        </div>
        <RightSection {...props} />
      </div>
    </div>
  );
};

export default Body;
